/**
 * Generic game categorized collection — tabs + cloned Dawn cards only (no sticker/filter lane).
 */
(function () {
  function safeJsonParse(text, label) {
    try {
      return JSON.parse(text);
    } catch (e) {
      console.warn('[game-collection] invalid JSON (' + label + ')', e);
      return null;
    }
  }

  function getTabIds(data) {
    var ids = [];
    if (data.config && data.config.showAllTab) ids.push('all');
    var cats = Array.isArray(data.categories) ? data.categories : [];
    for (var i = 0; i < cats.length; i++) {
      if (cats[i].id) ids.push(String(cats[i].id));
    }
    return ids;
  }

  function resolveInitialTab(data) {
    var ids = getTabIds(data);
    if (!ids.length) {
      console.warn('[game-collection] No tabs — add category blocks or enable All tab.');
      return null;
    }
    var want = data.config && data.config.defaultTab != null ? String(data.config.defaultTab) : '';
    if (want && ids.indexOf(want) === -1) {
      console.warn('[game-collection] defaultTab "' + want + '" unavailable; using "' + ids[0] + '".');
      want = ids[0];
    } else if (!want) {
      want = ids[0];
    }
    return want;
  }

  function findCategory(data, slug) {
    var cats = Array.isArray(data.categories) ? data.categories : [];
    for (var i = 0; i < cats.length; i++) {
      if (cats[i].id === slug) return cats[i];
    }
    return null;
  }

  function setTabAccessibility(tabs, activeId) {
    for (var i = 0; i < tabs.length; i++) {
      var slug = tabs[i].getAttribute('data-game-cat-tab') || '';
      var sel = slug === activeId;
      tabs[i].setAttribute('aria-selected', sel ? 'true' : 'false');
      tabs[i].tabIndex = sel ? 0 : -1;
      tabs[i].classList.toggle('mogo-cat__tab--active', sel);
    }
  }

  function scrollGameCatTabChipIntoRail(tabs, activeId) {
    if (!tabs || !tabs.length) return;
    var rail =
      tabs[0].closest && tabs[0].closest('.mogo-cat__tabs-scroll');
    if (!rail || rail.scrollWidth <= rail.clientWidth + 1) return;
    var chip = null;
    for (var j = 0; j < tabs.length; j++) {
      var id = tabs[j].getAttribute('data-game-cat-tab') || '';
      if (id === activeId) {
        chip = tabs[j];
        break;
      }
    }
    if (!chip) return;
    requestAnimationFrame(function () {
      try {
        chip.scrollIntoView({
          behavior: 'auto',
          block: 'nearest',
          inline: 'center'
        });
      } catch (e) {}
    });
  }

  function bindMoGoTabsRailSwipe(rail) {
    if (!rail || typeof window.PointerEvent === 'undefined') return;
    if (rail.getAttribute('data-mogo-tab-rail-swipe') === '1') return;
    rail.setAttribute('data-mogo-tab-rail-swipe', '1');

    var MOVE_GATE = 10;
    var active = false;
    var ptrId = null;
    var startClientX = 0;
    var startClientY = 0;
    var lastClientX = 0;
    var dragging = false;
    var suppressNextClick = false;

    rail.addEventListener(
      'click',
      function (ev) {
        if (!suppressNextClick) return;
        ev.preventDefault();
        ev.stopPropagation();
        suppressNextClick = false;
      },
      true
    );

    function grabEnd() {
      active = false;
      ptrId = null;
      dragging = false;
      rail.classList.remove('mogo-cat__tabs-scroll--grabbing');
    }

    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      active = true;
      ptrId = e.pointerId;
      startClientX = e.clientX;
      startClientY = e.clientY;
      lastClientX = e.clientX;
      dragging = false;
      suppressNextClick = false;
    });

    rail.addEventListener(
      'pointermove',
      function (e) {
        if (!active || e.pointerId !== ptrId) return;
        var dx = e.clientX - startClientX;
        var dy = e.clientY - startClientY;

        if (!dragging) {
          if (Math.abs(dx) < MOVE_GATE && Math.abs(dy) < MOVE_GATE) return;
          if (Math.abs(dy) >= Math.abs(dx)) {
            grabEnd();
            return;
          }
          dragging = true;
          suppressNextClick = true;
          rail.classList.add('mogo-cat__tabs-scroll--grabbing');
          lastClientX = e.clientX;
          try {
            rail.setPointerCapture(ptrId);
          } catch (err) {}
          return;
        }

        var delta =
          window.getComputedStyle(rail).direction === 'rtl'
            ? e.clientX - lastClientX
            : lastClientX - e.clientX;
        rail.scrollLeft += delta;
        lastClientX = e.clientX;
        e.preventDefault();
      },
      { passive: false }
    );

    function releasePointer(e) {
      if (!active || ptrId == null || e.pointerId !== ptrId) return;
      if (dragging) {
        try {
          rail.releasePointerCapture(ptrId);
        } catch (err2) {}
      } else {
        suppressNextClick = false;
      }
      grabEnd();
    }

    rail.addEventListener('pointerup', releasePointer);
    rail.addEventListener('pointercancel', releasePointer);
  }

  function initRoot(root) {
    if (root.getAttribute('data-game-collection-bound') === 'true') return;

    var jsonId = root.getAttribute('data-game-cat-json-id') || '';
    var gridId = root.getAttribute('data-game-cat-grid-id') || '';
    var sectionId = root.getAttribute('data-game-cat-section-id') || '';

    var jsonEl = jsonId ? document.getElementById(jsonId) : null;
    var grid = gridId ? document.getElementById(gridId) : null;

    if (!jsonEl || !grid) return;

    var data = safeJsonParse(jsonEl.textContent || '{}', jsonId);
    if (!data) return;

    var initialTab = resolveInitialTab(data);
    if (initialTab == null) return;

    var tabs = [];
    root.querySelectorAll('[data-game-cat-tab]').forEach(function (b) {
      tabs.push(b);
    });

    var tabsRail = root.querySelector('.mogo-cat__tabs-scroll');
    if (
      tabsRail &&
      typeof window.matchMedia === 'function' &&
      window.matchMedia('(max-width: 749px)').matches
    ) {
      bindMoGoTabsRailSwipe(tabsRail);
    }

    var products = Array.isArray(data.products) ? data.products : [];
    var strings = data.strings || {};
    var activeTab = initialTab;

    function applyRender() {
      var cat = findCategory(data, activeTab);
      var isAll = activeTab === 'all';
      var fragHtml = '';

      function pushEmpty(msg) {
        fragHtml +=
          '<li class="grid__item game-cat__grid-empty" style="grid-column: 1 / -1;"><p class="mogo-cat__muted">' +
          String(msg || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;') +
          '</p></li>';
      }

      function collectHandlesOrdered() {
        var handles = [];
        if (isAll) {
          for (var p = 0; p < products.length; p++) handles.push(products[p].handle);
          return handles;
        }
        if (!cat || !cat.productHandles) return handles;
        for (var i = 0; i < cat.productHandles.length; i++) {
          handles.push(cat.productHandles[i]);
        }
        return handles;
      }

      var ord = collectHandlesOrdered();
      if (!ord.length && !isAll) {
        pushEmpty(strings.emptyCategory || '');
      }
      for (var h = 0; h < ord.length; h++) {
        var handle = ord[h];
        var tmpl = document.getElementById('GameCatCard-' + sectionId + '-' + handle);
        if (tmpl && tmpl.content && tmpl.tagName === 'TEMPLATE') {
          var node = tmpl.content.firstElementChild ? tmpl.content.firstElementChild.cloneNode(true) : null;
          if (node && node.outerHTML) fragHtml += node.outerHTML;
        }
      }

      grid.innerHTML = fragHtml;
    }

    function activateTab(slug, focusTab) {
      activeTab = slug;
      setTabAccessibility(tabs, slug);
      for (var ti = 0; ti < tabs.length; ti++) {
        if (tabs[ti].getAttribute('data-game-cat-tab') === slug) {
          if (focusTab) tabs[ti].focus();
          break;
        }
      }
      scrollGameCatTabChipIntoRail(tabs, slug);
      applyRender();
    }

    var tablist = root.querySelector('[role="tablist"]');
    if (tablist) {
      tablist.addEventListener('keydown', function (e) {
        var tabEls = [];
        for (var i = 0; i < tabs.length; i++) tabEls.push(tabs[i]);
        var idx = tabEls.indexOf(document.activeElement);
        if (e.key === 'ArrowRight') {
          e.preventDefault();
          idx = (idx + 1 + tabEls.length) % tabEls.length;
          activateTab(tabEls[idx].getAttribute('data-game-cat-tab') || '', true);
        } else if (e.key === 'ArrowLeft') {
          e.preventDefault();
          idx = idx <= 0 ? tabEls.length - 1 : idx - 1;
          activateTab(tabEls[idx].getAttribute('data-game-cat-tab') || '', true);
        } else if (e.key === 'Home') {
          e.preventDefault();
          activateTab(tabEls[0].getAttribute('data-game-cat-tab') || '', true);
        } else if (e.key === 'End') {
          e.preventDefault();
          activateTab(tabEls[tabEls.length - 1].getAttribute('data-game-cat-tab') || '', true);
        }
      });
    }

    tabs.forEach(function (btn) {
      btn.addEventListener('click', function () {
        activateTab(btn.getAttribute('data-game-cat-tab') || '', false);
      });
    });

    activateTab(initialTab, false);

    root.setAttribute('data-game-collection-bound', 'true');
  }

  function boot() {
    document.querySelectorAll('[data-game-cat-root]').forEach(initRoot);
  }

  document.addEventListener('shopify:section:load', function (ev) {
    var sid = ev.detail != null && ev.detail.sectionId != null ? String(ev.detail.sectionId) : '';
    if (!sid) return;
    document.querySelectorAll('[data-game-cat-root]').forEach(function (r) {
      if ((r.getAttribute('data-game-cat-section-id') || '') === sid) {
        initRoot(r);
      }
    });
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
